import React from 'react';
import { Box } from '@mui/material';
import { InvoiceList } from '../components/InvoiceList';

const InvoicesPage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <InvoiceList />
    </Box>
  );
};

export default InvoicesPage;